import { render, staticRenderFns } from "./RUTInput.vue?vue&type=template&id=3312ffdd&lang=pug&"
import script from "./RUTInput.vue?vue&type=script&lang=js&"
export * from "./RUTInput.vue?vue&type=script&lang=js&"
import style0 from "./RUTInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RUTInput.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VTextField,
})
